import axiosCreate from "axios"
import { apiURl } from "../helpers";
import Cookies from 'js-cookie'
export class axios{
    baseUrl;
    constructor(){
        //this.baseUrl=(window.location.hostname==="localhost"?window.env.REACT_APP_API_URL:`http://${window.location.hostname}/www/Aletheia-Aimall/react_api`)
         this.baseUrl=apiURl
    }
    axiosConfig(){
        return axiosCreate.create({
                baseURL:this.baseUrl,
                headers:{
                Authorization:Cookies.get(`${process.env.NODE_ENV}-userToken`),
                ContentType: 
                'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
               }
               
            })
        }
}